import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  BottomNavigation, 
  BottomNavigationAction, 
  Paper,
  Badge,
} from '@mui/material';
import {
  Home as HomeIcon,
  Build as MachinesIcon,
  QrCodeScanner as ScannerIcon,
  Person as ProfileIcon,
} from '@mui/icons-material';
import { useAppSelector } from '../../store/hooks';

interface MobileBottomNavigationProps {
  onQRScanClick?: () => void;
}

export const MobileBottomNavigation: React.FC<MobileBottomNavigationProps> = ({ onQRScanClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { machines } = useAppSelector((state) => state.machines);
  
  // Determine active tab based on current route
  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path.startsWith('/machines')) return 1;
    if (path.startsWith('/profile') || path.startsWith('/settings')) return 3;
    return 0; // Default to home
  };

  const handleNavigation = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/machines');
        break;
      case 2:
        if (onQRScanClick) {
          onQRScanClick();
        }
        break;
      case 3:
        // Navigate to profile or settings page (when implemented)
        navigate('/profile');
        break;
    }
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1200,
        display: { xs: 'block', md: 'none' }, // Only show on mobile
      }} 
      elevation={8}
    >
      <BottomNavigation
        value={getActiveTab()}
        onChange={handleNavigation}
        sx={{
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            px: 1,
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        <BottomNavigationAction
          label="Home"
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          label="Maschinen"
          icon={
            <Badge badgeContent={machines.length} color="primary" max={99}>
              <MachinesIcon />
            </Badge>
          }
        />
        <BottomNavigationAction
          label="Scannen"
          icon={<ScannerIcon />}
        />
        <BottomNavigationAction
          label="Profil"
          icon={<ProfileIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};